'use strict';
import StringHelper from '../../global/StringHelper';
import sxQuery from '../../sxQuery/sxQuery';
import SxQueryUtils from '../../sxQuery/SxQueryUtils';
import FilterPosition from '../enums/FilterPosition';
import CategoryTree from './CategoryTree';
import ColorTileFilter from './ColorTileFilter';
import FilterCheckbox from './FilterCheckbox';
import Icons from './Icons';
import RangeSlider from './RangeSlider';
var ACTIVE_TOP_BUTTON_CLASSNAME = 'ss360-filter__button--active ss360-ac-bg ss360-ac-b ss360-ac-bg--hover';
var INACTIVE_TOP_BUTTON_CLASSNAME = 'ss360-tc-c ss360-tc-c--hover ss360-white-bg--hover';
var createFilterId = function (key) { return "ss360-filter-".concat(StringHelper.getSafeKey(key)); };
var FilterType;
(function (FilterType) {
    FilterType["Multiselect"] = "multiselect";
    FilterType["Range"] = "range";
    FilterType["CategoryTree"] = "category-tree";
    FilterType["Color"] = "color";
    FilterType["Boolean"] = "boolean";
})(FilterType || (FilterType = {}));
var disableKeyboardActions = function (wrapper) {
    wrapper.find('button:not(.ss360-filter__button), input').attr('tabindex', '-1');
    wrapper.find("div[tabindex='0']").attr('tabindex', '-1');
};
var enableKeyboardActions = function (wrapper) {
    wrapper.find('button:not(.ss360-filter__button), input').attr('tabindex', null);
    wrapper.find("div[tabindex='-1']").attr('tabindex', '0');
};
var updateClearButton = function (wrapper, isSelected, clearButton) {
    if (clearButton === undefined) {
        clearButton = wrapper.find('.ss360-filter__clear-group');
    }
    if (isSelected) {
        clearButton.show();
        wrapper.addClass('ss360-filter__group--selected');
    }
    else {
        wrapper.removeClass('ss360-filter__group--selected');
        clearButton.hide();
    }
};
var currentId = 0;
var FilterGroupBuilder = /** @class */ (function () {
    function FilterGroupBuilder(context, onExpand, onChange, persistentFilterOptions, filterViewGroupCache) {
        this.context = context;
        this.pluginConfiguration = context.pluginConfiguration;
        this.onExpand = onExpand;
        this.onChange = onChange;
        this.persistentFilterOptions = persistentFilterOptions;
        this.filterViewGroupCache = filterViewGroupCache;
    }
    FilterGroupBuilder.prototype.setOnChange = function (onChange) {
        this.onChange = onChange;
    };
    FilterGroupBuilder.prototype.hideGroup = function (key, toggling) {
        var _this = this;
        if (toggling === void 0) { toggling = false; }
        var cacheEntry = this.filterViewGroupCache.groupByKey[key];
        var wrapper = cacheEntry.wrapper;
        var content = cacheEntry.content;
        var button = cacheEntry.button;
        var icon = cacheEntry.icon;
        SxQueryUtils.requestAnimationFrame(function () {
            wrapper.removeClass('ss360-filter__group--active');
            content.css('opacity', null);
            if (toggling) {
                button.removeClass(ACTIVE_TOP_BUTTON_CLASSNAME);
                button.addClass(INACTIVE_TOP_BUTTON_CLASSNAME);
                icon.find('path').attr('fill', _this.pluginConfiguration.style.themeColor);
            }
            else {
                button.removeClass('ss360-filter__button--active');
            }
            content.removeClass('ss360-filter__content--active');
            icon.removeClass('ss360-filter__button-icon--active');
        });
        if (this.filterViewGroupCache.activeGroups.indexOf(key) !== -1) {
            this.filterViewGroupCache.activeGroups.splice(this.filterViewGroupCache.activeGroups.indexOf(key), 1);
        }
    };
    FilterGroupBuilder.prototype.showGroup = function (key, hideOthers) {
        var _this = this;
        if (hideOthers === void 0) { hideOthers = false; }
        if (hideOthers) {
            this.filterViewGroupCache.activeGroups.forEach(function (groupKey) {
                _this.hideGroup(groupKey, true);
            });
        }
        var cacheEntry = this.filterViewGroupCache.groupByKey[key];
        SxQueryUtils.requestAnimationFrame(function () {
            cacheEntry.wrapper.addClass('ss360-filter__group--active');
            cacheEntry.icon.addClass('ss360-filter__button-icon--active');
            cacheEntry.button.addClass('ss360-filter__button--active');
            setTimeout(function () {
                cacheEntry.content.addClass('ss360-filter__content--active');
            }, 300);
            cacheEntry.content.css('opacity', '1');
        });
        if (this.filterViewGroupCache.activeGroups.indexOf(key) === -1) {
            this.filterViewGroupCache.activeGroups.push(key);
        }
    };
    FilterGroupBuilder.prototype.toggleGroup = function (key) {
        var _this = this;
        var cacheEntry = this.filterViewGroupCache.groupByKey[key];
        var wrapper = cacheEntry.wrapper;
        var wasActive = wrapper.hasClass('ss360-filter__group--active');
        var $bodyAndContent = sxQuery('body, .ss360-layer__content');
        var button = cacheEntry.button;
        var icon = cacheEntry.icon;
        if (wasActive) {
            if (button !== undefined) {
                button.removeClass(ACTIVE_TOP_BUTTON_CLASSNAME);
                button.addClass(INACTIVE_TOP_BUTTON_CLASSNAME);
            }
            if (icon !== undefined) {
                icon.find('path').attr('fill', this.pluginConfiguration.style.themeColor);
            }
            this.hideGroup(key);
            this.persistentFilterOptions.ss360ActiveGroup = undefined;
            $bodyAndContent.off("click.".concat(this.context.generateId('ss360ToggleGroup')));
            return;
        }
        if (button !== undefined) {
            button.addClass(ACTIVE_TOP_BUTTON_CLASSNAME);
            button.removeClass(INACTIVE_TOP_BUTTON_CLASSNAME);
        }
        if (icon !== undefined) {
            icon.find('path').attr('fill', '#fefefe');
        }
        this.persistentFilterOptions.ss360ActiveGroup = key;
        $bodyAndContent.off("click.".concat(this.context.generateId('ss360ToggleGroup')));
        this.showGroup(key, true);
        var contentLayer = cacheEntry.content;
        var layer = this.filterViewGroupCache.layer;
        var offsetLeft = cacheEntry.offsetLeft;
        if (offsetLeft === undefined) {
            var resizeEventName_1 = "resize.".concat(this.context.generateId('ss360RecalculateStyles'));
            sxQuery(window).off(resizeEventName_1).on(resizeEventName_1, function () {
                Object.keys(_this.filterViewGroupCache.groupByKey).forEach(function (group) {
                    var entry = _this.filterViewGroupCache.groupByKey[group];
                    entry.offsetLeft = undefined;
                });
                sxQuery(window).off(resizeEventName_1);
            });
        }
        if (offsetLeft === undefined) {
            SxQueryUtils.requestAnimationFrame(function () {
                if (offsetLeft === undefined) {
                    // @ts-ignore
                    var layerWidth = layer.width();
                    var buttonLayerOffset = cacheEntry.button === undefined ? 0 : cacheEntry.button.offset().left - layer.offset().left;
                    var MAX_CONTENT_WIDTH = 300;
                    if (buttonLayerOffset + MAX_CONTENT_WIDTH < layerWidth) {
                        offsetLeft = 0;
                    }
                    else {
                        offsetLeft = layerWidth - buttonLayerOffset - MAX_CONTENT_WIDTH;
                    }
                    cacheEntry.offsetLeft = offsetLeft;
                    contentLayer.css('left', offsetLeft);
                }
            });
        }
        $bodyAndContent.on("click.".concat(this.context.generateId('ss360ToggleGroup')), function (e) {
            if (sxQuery(e.target).is(wrapper) || sxQuery(e.target).parents('.ss360-filter__content').length > 0) {
                return; // self click
            }
            _this.toggleGroup(key);
        });
        if (this.onExpand !== undefined && typeof this.onExpand === 'function') {
            this.onExpand();
        }
        wrapper.off('click.ss360PreventBubble');
        wrapper.on('click.ss360PreventBubble', function (e) {
            if (sxQuery(e.target).parents('.ss360-filter__content').length === 0) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
        if (this.filterViewGroupCache.filters !== undefined) {
            this.filterViewGroupCache.filters.forEach(function (group) {
                group.mount();
            });
        }
    };
    FilterGroupBuilder.prototype.createOrGetWrapper = function (key, label, type, hasSelectedOptions) {
        var _this = this;
        var position = this.pluginConfiguration.filters.position;
        var filterId = createFilterId(key);
        var shouldShow = position === 'left' && this.persistentFilterOptions.collapsedFilterGroups.indexOf(key) === -1;
        var cacheEntry = this.filterViewGroupCache.groupByKey[key];
        var entryExists = cacheEntry !== undefined;
        var wrapper;
        if (entryExists) {
            wrapper = cacheEntry.wrapper;
        }
        else {
            var plainWrapper = document.createElement('section');
            plainWrapper.setAttribute('id', filterId);
            plainWrapper.className = "ss360-n-section ss360-filter__group ss360-".concat(type, "-filter ss360-").concat(type, "-filter--").concat(position, " ").concat(shouldShow ? 'ss360-filter__group--active' : '');
            plainWrapper.setAttribute('aria-label', label);
            wrapper = sxQuery(plainWrapper);
        }
        var themeColor = this.pluginConfiguration.style.themeColor;
        var iconSvg = Icons.getSvgIconNode(Icons.SIMPLE_ARROW, (position === 'left' ? '#4a4f62' : themeColor));
        var icon;
        if (entryExists) {
            icon = cacheEntry.icon;
        }
        else {
            var iconPlain = document.createElement('i');
            iconPlain.className = "ss360-filter__button-icon ".concat(shouldShow ? 'ss360-filter__button-icon--active' : '');
            iconPlain.appendChild(iconSvg);
            icon = sxQuery(iconPlain);
        }
        var button;
        if (entryExists) {
            button = cacheEntry.button;
        }
        else {
            var buttonPlain = document.createElement('button');
            buttonPlain.className = 'ss360-filter__button ss360-flex ss360-flex--align-center ss360-n-button';
            buttonPlain.innerText = label;
            button = sxQuery(buttonPlain);
        }
        if (!entryExists && position === 'top') {
            if (shouldShow) {
                button.addClass(ACTIVE_TOP_BUTTON_CLASSNAME);
                icon.find('path').attr('fill', '#fefefe');
            }
            else {
                button.addClass(INACTIVE_TOP_BUTTON_CLASSNAME);
            }
        }
        var content;
        if (entryExists) {
            content = cacheEntry.content;
        }
        else {
            var contentPlain = document.createElement('div');
            contentPlain.className = "ss360-filter__content".concat(shouldShow ? ' ss360-filter__content--active' : '');
            content = sxQuery(contentPlain);
        }
        var skipButton;
        if (entryExists) {
            skipButton = cacheEntry.skipButton;
        }
        else {
            var skipButtonPlain = document.createElement('button');
            skipButtonPlain.className = 'ss360-skip-link ss360-skip-link--group ss360-n-button';
            skipButtonPlain.setAttribute('type', 'button');
            skipButtonPlain.innerText = 'Skip Filter Group';
            skipButton = sxQuery(skipButtonPlain);
        }
        var clearButton;
        if (entryExists) {
            clearButton = cacheEntry.clearButton;
        }
        else {
            var clearButtonPlain = document.createElement('button');
            clearButtonPlain.className = 'ss360-filter__clear-group ss360-n-button';
            clearButtonPlain.setAttribute('type', 'button');
            var i = document.createElement('i');
            i.innerHTML = '&times;';
            clearButtonPlain.appendChild(i);
            clearButtonPlain.innerHTML += " ".concat(this.pluginConfiguration.filters.clearGroupLabel);
            clearButton = sxQuery(clearButtonPlain);
        }
        updateClearButton(wrapper, hasSelectedOptions, clearButton);
        if (entryExists) {
            clearButton.off('click.ss360ClearFilter');
        }
        clearButton.on('click.ss360ClearFilter', function () {
            _this.onChange(key, undefined, label);
            clearButton.fadeOut();
        });
        if (entryExists) {
            content.empty();
        }
        else {
            button.append(icon);
            wrapper.append(button);
            wrapper.append(content);
            skipButton.on('click', function (e) {
                var groupParent = e.target.parentNode.parentNode;
                if (groupParent.nextSibling === null) {
                    _this.context.getExistingLayer().find('.ss360-suggests:first .ss360-suggests__link').focus();
                }
                else {
                    sxQuery(groupParent.nextSibling).find('.ss360-filter__button').focus();
                }
            });
        }
        content.prepend(clearButton); // should be shown just after the skip button (tab order)
        content.prepend(skipButton);
        this.filterViewGroupCache.groupByKey[key] = {
            wrapper: wrapper,
            content: content,
            button: button,
            icon: icon,
            skipButton: skipButton,
            clearButton: clearButton
        };
        if (position === 'top' && !entryExists) {
            button.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this.toggleGroup(key);
            });
        }
        else if (position === 'left') {
            var activeGroupIdx = this.filterViewGroupCache.activeGroups.indexOf(key);
            if (!shouldShow) {
                disableKeyboardActions(wrapper);
                content.css('height', 0);
                content.data('heightcache', 'auto');
                content.attr('aria-hidden', 'true');
                if (activeGroupIdx !== -1) {
                    this.filterViewGroupCache.activeGroups.splice(activeGroupIdx, 1);
                }
            }
            else {
                content.attr('aria-hidden', 'false');
                if (activeGroupIdx === -1) {
                    this.filterViewGroupCache.activeGroups.push(key);
                }
            }
            if (!entryExists) {
                button.on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (_this.filterViewGroupCache.activeGroups.indexOf(key) !== -1) { // hide
                        _this.fullyHide(key, wrapper, content);
                    }
                    else { // show
                        _this.fullyShow(key, wrapper, content);
                    }
                });
            }
        }
        return wrapper;
    };
    FilterGroupBuilder.prototype.fullyHide = function (key, wrapper, content) {
        this.hideGroup(key);
        var outerHeight = content.outerHeight();
        if (content.data('heightcache') === undefined) { // don't cache if the animation wasn't completed
            content.data('heightcache', outerHeight);
        }
        content.css('height', outerHeight);
        content.attr('aria-hidden', 'true');
        SxQueryUtils.requestAnimationFrame(function () {
            content.css('height', 0);
        });
        this.persistentFilterOptions.collapsedFilterGroups.push(key);
        disableKeyboardActions(wrapper);
    };
    FilterGroupBuilder.prototype.fullyShow = function (key, wrapper, content) {
        this.showGroup(key, false);
        content.attr('aria-hidden', 'false');
        content.css('height', content.data('heightcache'));
        setTimeout(function () {
            content.css('height', 'auto');
            content.data('heightcache', null);
        }, 300);
        if (this.persistentFilterOptions.collapsedFilterGroups.indexOf(key) !== -1) {
            this.persistentFilterOptions.collapsedFilterGroups.splice(this.persistentFilterOptions.collapsedFilterGroups.indexOf(key), 1);
        }
        enableKeyboardActions(wrapper);
    };
    FilterGroupBuilder.prototype.generateId = function () {
        currentId++;
        return currentId;
    };
    FilterGroupBuilder.prototype.multipleChoice = function (key, label, options, activeOptions, counts, isColorFilter, filterModificationMap, isBooleanFilter, disableSearch) {
        var _this = this;
        if (filterModificationMap === void 0) { filterModificationMap = {}; }
        if (isBooleanFilter === void 0) { isBooleanFilter = false; }
        if (disableSearch === void 0) { disableSearch = false; }
        activeOptions = isBooleanFilter ? activeOptions : activeOptions || [];
        var wrapper = this.createOrGetWrapper(key, label, FilterType.Multiselect, isBooleanFilter ? activeOptions !== undefined : activeOptions.length > 0);
        var inputWrapper = sxQuery('<div role="group" class="ss360-multiselect"></div>');
        var filterConfig = this.pluginConfiguration.filters;
        var filterPosition = filterConfig.position;
        var checkboxWrapper = sxQuery("<div class=\"ss360-multiselect__wrap ss360-flex ".concat(filterPosition === FilterPosition.Left
            ? 'ss360-flex--nowrap ss360-flex--column' : 'ss360-flex--wrap', "\"></div>"));
        var searchDisplayed = false;
        var emptyStateElement;
        var selectedValues = activeOptions;
        var updateSelectedValues = function () {
            selectedValues = activeOptions;
            if (_this.pluginConfiguration.results.nameParsing && !isBooleanFilter && selectedValues.length > 0) { // get the original case for displaying and updating
                var caseMap_1 = options.reduce(function (acc, option) {
                    acc[option.name.toLowerCase()] = option.name;
                    return acc;
                }, {});
                selectedValues = selectedValues.map(function (val) { return (caseMap_1[val] === undefined ? val : caseMap_1[val]); });
            }
        };
        updateSelectedValues();
        var checkboxes = {};
        var shouldOfferSearch = options.length > filterConfig.multiSelectSearchThreshold;
        var optionsToShow = filterConfig.multiSelectShowMoreThreshold;
        var getIsExpanded = function () { return options.length <= optionsToShow || _this.filterViewGroupCache.expandedGroups[key] === true; };
        var isExpanded = getIsExpanded();
        var showMoreButton;
        var availableOptions = options.length;
        var getOptionKey = function (option) { return option.value !== undefined ? option.value : option.key; };
        var runQueryFilter = function (filterQuery) {
            var matchingOptionCount = 0;
            options.forEach(function (option) {
                var checkbox = checkboxes[getOptionKey(option)];
                if (checkbox === undefined) {
                    return;
                }
                var matches = filterQuery.length === 0 || option.name.toLowerCase().indexOf(filterQuery) !== -1; // indexOf seems to perform better than regexp in this case
                if (matches) {
                    matchingOptionCount++;
                    if (isExpanded || matchingOptionCount <= optionsToShow) {
                        checkbox.show();
                    }
                    else {
                        checkbox.hide();
                    }
                }
                else {
                    checkbox.hide();
                }
            });
            availableOptions = matchingOptionCount;
            updateShowMoreButton();
            if (matchingOptionCount === 0 && emptyStateElement !== undefined) {
                emptyStateElement.show();
            }
            else if (emptyStateElement !== undefined) {
                emptyStateElement.hide();
            }
        };
        var updateShowMoreButton = function () {
            if (showMoreButton === undefined)
                return;
            if (availableOptions <= optionsToShow) {
                showMoreButton.hide();
                return;
            }
            showMoreButton.show();
            var diffString = (availableOptions - optionsToShow).toString();
            var text = !isExpanded ? filterConfig.multiSelectShowMoreLabel : filterConfig.multiSelectShowLessLabel;
            showMoreButton.text(text.replace(/#COUNT#/g, diffString));
        };
        var removeSearch = function () {
            inputWrapper.find('.ss360-multiselect__search, .ss360-multiselect__empty-state').remove();
            searchDisplayed = false;
        };
        var renderSearch = function () {
            if (searchDisplayed) {
                return;
            }
            var icon = Icons.getBase64EncodedIcon(Icons.MAGNIFIER, '#626262');
            var filterInput = sxQuery("<input type=\"search\" style=\"background-image:url(".concat(icon, ");\" \n\t\t\t\tclass=\"ss360-multiselect__search\" placeholder=\"").concat(filterConfig.multiSelectSearchLabel.replace(/#FILTER_NAME#/g, label), "\">"));
            if (_this.filterViewGroupCache.searchQueries[key] !== undefined) {
                filterInput.val(_this.filterViewGroupCache.searchQueries[key]);
            }
            inputWrapper.prepend(filterInput);
            emptyStateElement = sxQuery("<span style=\"display:none;\" class=\"ss360-multiselect__empty-state\">".concat(filterConfig.multiSelectEmptyState, "</span>"));
            inputWrapper.append(emptyStateElement);
            filterInput.on('input', function (e) {
                // @ts-ignore
                var filterQuery = sxQuery(e.target).val().trim().toLowerCase();
                _this.filterViewGroupCache.searchQueries[key] = filterQuery;
                runQueryFilter(filterQuery);
            });
            searchDisplayed = true;
        };
        if (shouldOfferSearch && !disableSearch) {
            renderSearch();
        }
        var onCheckboxChange = function (value, checked) {
            // @ts-ignore
            var idx = isBooleanFilter ? -1 : selectedValues.indexOf(value);
            if (!isBooleanFilter && idx === -1 && !checked) { // TODO: clean this fucking shit up, values, names, name parsing, arrrrgh
                Object.keys(filterModificationMap).forEach(function (displayVal) {
                    var realVal = filterModificationMap[displayVal];
                    if (realVal === value) {
                        // @ts-ignore
                        idx = selectedValues.indexOf(displayVal);
                    }
                });
            }
            if (checked && idx === -1 && !isBooleanFilter) {
                // @ts-ignore
                selectedValues.push(value);
            }
            else if (!checked && idx !== -1 && !isBooleanFilter) {
                // @ts-ignore
                selectedValues.splice(idx, 1);
            }
            if (!isBooleanFilter) {
                selectedValues = selectedValues.map(function (val) { return filterModificationMap[val] || val; });
            }
            if (_this.onChange !== undefined && typeof _this.onChange === 'function') {
                var filterValue = selectedValues;
                if (isBooleanFilter) {
                    // @ts-ignore
                    filterValue = checked ? value === 'true' || value === true : undefined;
                }
                _this.onChange((key || label), filterValue, label);
            }
        };
        var hasColor = false;
        var showCounts = filterConfig.showCounts;
        var safeKey = StringHelper.getSafeKey(key);
        var createCheckbox = function (option, idx) {
            var id = "ss360-checkbox-".concat(safeKey, "-").concat(_this.generateId());
            var c = undefined;
            if (showCounts && option.count !== undefined) {
                c = option.count;
            }
            else if (showCounts) {
                c = counts[option.key];
            }
            var count = showCounts && c !== undefined ? c : option.count;
            if (!showCounts) {
                count = undefined;
            }
            // @ts-ignore
            var isChecked = isBooleanFilter ? option.value === selectedValues : selectedValues.indexOf(option.key) !== -1;
            var optionKey = getOptionKey(option);
            var checkbox = new FilterCheckbox(optionKey, option.name, count, isChecked, id, isColorFilter && option.color !== undefined ? option.color : undefined, isExpanded || idx < optionsToShow, onCheckboxChange);
            if (isColorFilter && option.color !== undefined) {
                hasColor = true;
            }
            checkboxWrapper.append(checkbox.getDomNode());
            checkboxes[optionKey] = checkbox;
            return checkbox;
        };
        options.forEach(function (option, idx) {
            createCheckbox(option, idx);
        });
        if (shouldOfferSearch && this.filterViewGroupCache.searchQueries[key] !== undefined) {
            runQueryFilter(this.filterViewGroupCache.searchQueries[key]);
        }
        inputWrapper.append(checkboxWrapper);
        var renderShowMoreButton = function () {
            if (inputWrapper.find('.ss360-multiselect__show-more').length === 0) {
                showMoreButton = sxQuery('<button type="button" class="ss360-n-button ss360-multiselect__show-more"></button>');
                showMoreButton.on('click', function () {
                    isExpanded = !isExpanded;
                    _this.filterViewGroupCache.expandedGroups[key] = isExpanded;
                    var searchQuery = _this.filterViewGroupCache.searchQueries[key] !== undefined ? _this.filterViewGroupCache.searchQueries[key] : '';
                    runQueryFilter(searchQuery);
                });
                inputWrapper.append(showMoreButton);
            }
            updateShowMoreButton();
        };
        if (options.length > optionsToShow) {
            renderShowMoreButton();
        }
        if (hasColor) {
            inputWrapper.addClass('ss360-multiselect--color');
        }
        this.filterViewGroupCache.groupByKey[key].content.append(inputWrapper);
        var self = this;
        return {
            mount: function () { },
            addClass: function (className) {
                wrapper.addClass(className);
            },
            getWrapper: function () {
                return wrapper;
            },
            show: function () {
                _this.fullyShow(key, wrapper, wrapper.find('.ss360-filter__content'));
            },
            hide: function () {
                _this.fullyHide(key, wrapper, wrapper.find('.ss360-filter__content'));
            },
            update: function (filterGroup, active, modificationMap) {
                if (!isBooleanFilter) {
                    active = active || [];
                    updateClearButton(wrapper, active.length > 0);
                }
                else {
                    active = active && active !== undefined;
                    updateClearButton(wrapper, active);
                }
                options = (filterGroup.values || []);
                availableOptions = options.length;
                activeOptions = active;
                counts = filterGroup.counts || counts;
                filterModificationMap = modificationMap || filterModificationMap;
                updateSelectedValues();
                if (options.length > filterConfig.multiSelectSearchThreshold && !disableSearch) {
                    renderSearch();
                }
                else {
                    removeSearch();
                    _this.filterViewGroupCache.searchQueries[key] = '';
                }
                var flatOptions = options.map(function (option) { return getOptionKey(option); });
                var optionNameMap = {};
                var localCountMap = {};
                options.forEach(function (option) {
                    var key = getOptionKey(option);
                    optionNameMap[key] = option.name;
                    if (showCounts && option.count !== undefined) {
                        localCountMap[key] = option.count;
                    }
                });
                var isVisible = false;
                Object.keys(checkboxes).forEach(function (key) {
                    var checkbox = checkboxes[key];
                    if (checkbox === undefined) {
                        return;
                    }
                    if (flatOptions.indexOf(key) === -1) {
                        checkbox.remove();
                        checkboxes[key] = undefined;
                    }
                    else {
                        isVisible = true;
                        var valueKey = optionNameMap[key];
                        checkbox.updateActive(isBooleanFilter ? active : activeOptions.indexOf(valueKey) !== -1);
                        checkbox.updateCount(showCounts ? counts[key] || localCountMap[key] : undefined);
                    }
                });
                flatOptions.forEach(function (key, idx) {
                    if (checkboxes[key] !== undefined) {
                        return;
                    }
                    createCheckbox(options.filter(function (option) { return getOptionKey(option) === key; })[0], idx);
                });
                flatOptions.forEach(function (key, idx) {
                    var checkbox = checkboxes[key];
                    if (checkbox === undefined) {
                        return;
                    }
                    checkbox.ensureLastPosition(checkboxWrapper);
                });
                if (options.length > optionsToShow) {
                    renderShowMoreButton();
                }
                if (isBooleanFilter) {
                    Object.values(checkboxes).forEach(function (checkbox) {
                        // @ts-ignore
                        checkbox.updateActive(active === checkbox.key);
                    });
                }
                isExpanded = getIsExpanded();
                runQueryFilter(_this.filterViewGroupCache.searchQueries[key] || '');
                return isVisible || isBooleanFilter;
            },
            updateHandlers: function (onChange, onExpand) {
                self.onChange = onChange;
                self.onExpand = onExpand;
            }
        };
    };
    FilterGroupBuilder.prototype.range = function (key, label, min, max, step, unit, activeValues, singleFilterSetting, counts, isDate, datePrecision, fractionalDigits) {
        var _this = this;
        var wrapper = this.createOrGetWrapper(key, label, FilterType.Range, (activeValues || {}).min !== undefined);
        var sliderWrapper = sxQuery('<div class="ss360-slider"></div>');
        var drawHistogram = singleFilterSetting.drawHistogram !== undefined ? singleFilterSetting.drawHistogram : !isDate;
        if (!drawHistogram) {
            sliderWrapper.addClass('ss360-slider--no-histogram');
        }
        var minCache = activeValues !== undefined ? activeValues.min : min;
        var maxCache = activeValues !== undefined ? activeValues.max : max;
        this.filterViewGroupCache.groupByKey[key].content.append(sliderWrapper);
        var decimalPlaces = singleFilterSetting.decimalPlaces !== undefined ? singleFilterSetting.decimalPlaces : fractionalDigits;
        var slider = new RangeSlider(sliderWrapper, {
            min: min,
            max: max,
            step: step,
            unit: unit,
            drawHistogram: drawHistogram,
            isDate: isDate,
            showSlider: singleFilterSetting.showSlider !== undefined ? singleFilterSetting.showSlider : true,
            prefix: singleFilterSetting.prefix,
            postfix: singleFilterSetting.postfix,
            decimalPlaces: decimalPlaces,
            datePrecision: datePrecision
        }, counts, function (newMin, newMax) {
            if (minCache !== newMin || maxCache !== newMax) {
                minCache = newMin;
                maxCache = newMax;
                if (_this.onChange !== undefined && typeof _this.onChange === 'function') {
                    var obj = min === newMin && max === newMax ? undefined : {
                        min: newMin,
                        max: newMax
                    }; // empty object to notify that we can ignore this filter
                    _this.onChange((key || label), obj, label);
                }
            }
        }, this.context);
        if (activeValues !== undefined) {
            slider.setCurrentMin(Math.max(activeValues.min, min));
            slider.setCurrentMax(Math.min(activeValues.max, max));
            sliderWrapper.addClass('ss360-slider--selected');
        }
        var self = this;
        return {
            mount: function () { slider.mount(); },
            addClass: function (className) { wrapper.addClass(className); },
            getWrapper: function () { return wrapper; },
            show: function () {
                _this.fullyShow(key, wrapper, wrapper.find('.ss360-filter__content'));
            },
            hide: function () {
                _this.fullyHide(key, wrapper, wrapper.find('.ss360-filter__content'));
            },
            update: function (filterGroup, active) {
                if (filterGroup.min === filterGroup.max && (active === undefined || (active.min === undefined && active.max === undefined))) {
                    return false;
                }
                updateClearButton(wrapper, active !== undefined && active.min !== undefined);
                slider.updateMinMax(filterGroup.min, filterGroup.max, active ? active.min : undefined, active ? active.max : undefined, filterGroup.counts);
                return true;
            },
            updateHandlers: function (onChange, onExpand) {
                self.onChange = onChange;
                self.onExpand = onExpand;
            }
        };
    };
    FilterGroupBuilder.prototype.categoryTree = function (key, label, values, activeValue) {
        var _this = this;
        // const CategoryTreeFilter = function (key, label, values, activeValue) {
        var wrapper = this.createOrGetWrapper(key, label, FilterType.CategoryTree, (activeValue || []).length > 0);
        var treeWrapper = sxQuery('<div class="ss360-category-tree-wrapper"></div>');
        this.filterViewGroupCache.groupByKey[key].content.append(treeWrapper);
        var categoryTree = new CategoryTree(treeWrapper, values, activeValue, this.pluginConfiguration, function (val) {
            if (_this.onChange !== undefined && typeof _this.onChange === 'function') {
                var obj = val === undefined ? undefined : [val.toString()];
                _this.onChange((key || label), obj, label);
            }
        });
        var self = this;
        return {
            mount: function () { },
            addClass: function (className) { wrapper.addClass(className); },
            getWrapper: function () { return wrapper; },
            show: function () {
                _this.fullyShow(key, wrapper, wrapper.find('.ss360-filter__content'));
            },
            hide: function () {
                _this.fullyHide(key, wrapper, wrapper.find('.ss360-filter__content'));
            },
            update: function (filterGroup, active, values) {
                updateClearButton(wrapper, (active || []).length > 0);
                categoryTree.update(values, active);
                return (values || []).length > 0;
            },
            updateHandlers: function (onChange, onExpand) {
                self.onChange = onChange;
                self.onExpand = onExpand;
            }
        };
    };
    FilterGroupBuilder.prototype.color = function (key, label, options, activeOptions, counts, filterModificationMap) {
        var _this = this;
        if (filterModificationMap === void 0) { filterModificationMap = {}; }
        var showColorLabels = this.pluginConfiguration.filters.showColorLabels;
        if (activeOptions === undefined) {
            activeOptions = [];
        }
        var getInvertedFilterModificationMap = function () { return Object.keys(filterModificationMap).reduce(function (acc, mapKey) {
            acc[filterModificationMap[mapKey]] = mapKey;
            return acc;
        }, {}); };
        var wrapper = this.createOrGetWrapper(key, label, FilterType.Color, activeOptions.length > 0);
        var colorTileWrapper = showColorLabels ? sxQuery('<div class="ss360-color-tiles ss360-color-tiles--show-labels"></div>') : sxQuery('<div class="ss360-color-tiles"></div>');
        this.filterViewGroupCache.groupByKey[key].content.append(colorTileWrapper);
        var filter = new ColorTileFilter(colorTileWrapper, options, activeOptions, counts, this.pluginConfiguration.filters.showCounts, this.pluginConfiguration, function (value, active) {
            var invertedFilterModificationMap = getInvertedFilterModificationMap();
            if (!active && invertedFilterModificationMap[value] !== undefined) {
                value = invertedFilterModificationMap[value];
            }
            var idx = activeOptions.indexOf(value);
            if (active && idx === -1) {
                activeOptions.push(value);
            }
            else if (!active && idx !== -1) {
                activeOptions.splice(idx, 1);
            }
            if (_this.onChange !== undefined && typeof _this.onChange === 'function') {
                _this.onChange((key || label), activeOptions, label);
            }
        });
        var self = this;
        return {
            mount: function () { },
            addClass: function (className) { wrapper.addClass(className); },
            getWrapper: function () { return wrapper; },
            show: function () {
                _this.fullyShow(key, wrapper, wrapper.find('.ss360-filter__content'));
            },
            hide: function () {
                _this.fullyHide(key, wrapper, wrapper.find('.ss360-filter__content'));
            },
            update: function (filterGroup, active, modificationMap) {
                activeOptions = active || [];
                updateClearButton(wrapper, (active || []).length > 0);
                filterModificationMap = modificationMap || filterModificationMap;
                return filter.update(filterGroup, active);
            },
            updateHandlers: function (onChange, onExpand) {
                self.onChange = onChange;
                self.onExpand = onExpand;
            }
        };
    };
    return FilterGroupBuilder;
}());
export default FilterGroupBuilder;
